import React from 'react';
import '../styles/GlassPanel.css';

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

const GlassPanel = ({ children, title, className }) => {
  return (
    <div className={`glass-panel ${className || ''}`}>
      {title && <h2 className="panel-title">{title}</h2>}
      {children}
    </div>
  );
};

export default GlassPanel;